<template>
    <div class="platform-icon" :style="{ '--platform-width': `${size}px`, '--platform-height': `${size}px` }">
        <WhatsappSvg
            v-if="platform === 'whatsapp'"
            color="green"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Whatsapp'"
        />

        <Instagram
            v-else-if="platform === 'instagram'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Instagram'"
        />
        <MessengerIcon
            v-else-if="platform === 'messenger'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Messenger'"
        />
        <TelegramIcon
            v-else-if="platform === 'telegram'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Telegram'"
        />
        <WhatsappBusinessIcon
            v-else-if="platform === 'whatsapp-business-api'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Whatsapp Business API'"
            :color="'#59c864'"
        />
        <WhatsappV2
            v-else-if="platform === 'whatsapp-v2'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Web'"
            :color="'#59c864'"
        />

        <WhatsappV3Icon
            v-else-if="platform === 'whatsapp-unipile'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Whatsapp V3'"
            :color="'#59c864'"
        />
        <LinkedinIcon
            v-else-if="platform === 'linkedin'"
            :color="'#59c864'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Linkedin'"
        />
        <WhatsappSvg
            v-else-if="platform === 'notWp'"
            color="red"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Kanal silinmiş ya da bağlantısı koparılmıştır.'"
        />

        <BrowserSvg2
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Web'"
            v-else
        />
    </div>
</template>

<script>
import TelegramIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import WhatsappSvg from "../../svg/WhatsappSvg.vue";
import MessengerIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import BrowserSvg2 from "../../svg/Browser2Svg.vue";
import Instagram from "../../../../svg/stepper/Instagram.vue";
import WhatsappBusinessIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappV2 from "../../../../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import LinkedinIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import WhatsappV3Icon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";

export default {
    name: "PlatformIcon",
    components: {
        WhatsappV3Icon,
        LinkedinIcon,
        Instagram,
        BrowserSvg2,
        MessengerIcon,
        WhatsappSvg,
        WhatsappBusinessIcon,
        WhatsappV2,
        TelegramIcon,
    },
    props: {
        platform: {
            type: String,
            default: null,
        },
        size: {
            type: Number,
            default: 18,
        },
    },
};
</script>
<style lang="scss" scoped>
.platform-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--platform-width);
    height: var(--platform-height);

    svg {
        width: var(--platform-width);
        height: var(--platform-height);
    }
}
</style>
